import React, { useState } from "react";

import { useTranslation } from "react-i18next";

import Breadcrumb from "../../../../../../components/Generic/Breadcrump";
import SubHeader from "../../../../../../components/Generic/SubHeader";
import UITabMaterial, { PanelProps } from "../../../../../../components/Generic/UITabMaterial";
import { PRIVATE_ROUTES } from "../../../../../../constants";
import { useAppState } from "../../../../../../context/StateContext";
import { formatCurrency } from "../../../../../../util/prices";
import { StorageAccountDetails } from "./components/Details";
import InventoryTab from "./components/Inventory";
import {
  StorageAccountTotalContainer,
  StorageAccountTotalText,
  StorageAccountValue,
  StorageAccountsMaintenanceGrid,
} from "./styles";

// eslint-disable-next-line @typescript-eslint/naming-convention
enum TAB_SELECTED {
  DETAILS = "details",
  INVENTORY = "inventory",
}

export const StorageAccountMaintenance = () => {
  const { t: translate } = useTranslation();
  const { currentUser } = useAppState();

  const [leftPanelSelected, setLeftPanelSelected] = useState<string>(TAB_SELECTED.DETAILS);

  const detailsPanel: PanelProps = {
    key: "details",
    menuItem: translate("details"),
    render: () => <StorageAccountDetails />,
  };

  const inventoryPanel: PanelProps = {
    key: "inventory",
    menuItem: translate("inventory"),
    render: () => <InventoryTab />,
  };

  const leftPanels: PanelProps[] = [detailsPanel, inventoryPanel];

  const storageAccountTotalComponent = () => {
    return (
      <StorageAccountTotalContainer>
        <StorageAccountTotalText>{translate("totalGSTIncluded")}</StorageAccountTotalText>
        {`${translate("extraServices")}:`}
        <StorageAccountValue>{`${currentUser?.company?.currency?.symbol ?? "$"} ${formatCurrency(
          0,
          currentUser?.company?.currency,
          false
        )}`}</StorageAccountValue>
        {`${translate("grandTotal")}:`}
        <StorageAccountValue>{`${currentUser?.company?.currency?.symbol ?? "$"} ${formatCurrency(
          0,
          currentUser?.company?.currency,
          false
        )}`}</StorageAccountValue>
      </StorageAccountTotalContainer>
    );
  };

  return (
    <div>
      <SubHeader>
        <Breadcrumb
          items={[
            {
              title: translate("storageAccounts"),
              link: {
                url: PRIVATE_ROUTES.STORAGE_ACCOUNTS,
              },
            },
            {
              title: translate("createNewStorageAccount"),
              color: "#465869",
            },
          ]}
        />
      </SubHeader>
      <StorageAccountsMaintenanceGrid>
        <UITabMaterial
          leftPanels={leftPanels}
          rightComponent={storageAccountTotalComponent}
          showRightPanel={leftPanelSelected === TAB_SELECTED.DETAILS}
          onChangeLeftPanel={(event, panel, key) => key && setLeftPanelSelected(key)}
        />
      </StorageAccountsMaintenanceGrid>
    </div>
  );
};
